import React from "react";
import Headers from "../../../components/Headers";
import {
  Input,
  Form,
  Row,
  Col,
  Button,
  Table,
  Divider,
  message,
  Modal,
  Icon,
} from "antd";
import EditInstallEmployee from "../components/EditInstallEmployee";
import { fetchEmployeeList, fetchDeleteEmployee } from "../../../api/employee";
import NProgress from "nprogress";
import { Decrypt } from "../../../utils/secret";

const BreadCrumbData = [
  { path: "/page/employee/InstallEmployee", name: "人员" },
  { path: "/page/employee/InstallEmployee", name: "安装人员" },
];
const { Column } = Table;
class InstallEmployee extends React.Component {
  state = {
    account: "",
    deletevisible: false,
    isAdd: false,
    employeeInfo: {
      name: "",
      account: "",
      password: "",
    },
    visible: false,
    list: [],
    listQuery: {
      name: "",
      mobilePhone: "",
      type: "OPERATOR",
      pageSize: 10,
      pageNum: 1,
    },
    total: 0,
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState(
          {
            listQuery: { ...this.state.listQuery, ...values, pageNum: 1 },
          },
          () => {
            this.getEmployeeList();
            message.success("搜索成功");
          }
        );
      }
    });
  };
  handleCancel = () => {
    this.setState({
      employeesId: "",
      visible: false,
      employeeInfo: {
        name: "",
        account: "",
        password: "",
      },
    });
  };
  deleteOk = () => {
    fetchDeleteEmployee({ employeesId: this.state.employeesId }).then((res) => {
      if (res.success) {
        message.success("删除成功");
        if (
          this.state.list.length === 1 &&
          this.state.listQuery.pageNum !== 1
        ) {
          this.setState({
            listQuery: {
              ...this.state.listQuery,
              pageNum: this.state.listQuery.pageNum - 1,
            },
          });
        }
        this.getEmployeeList({ ...this.state.listQuery });
      }
    });
    this.setState({
      deletevisible: false,
    });
  };
  async componentDidMount() {
    NProgress.start();
    await this.getEmployeeList();
    NProgress.done();
  }
  getEmployeeList = () => {
    fetchEmployeeList(this.state.listQuery).then((res) => {
      if (res.success) {
        if (res.data.list) {
          res.data.list.forEach((item) => {
            item.mobilePhone = Decrypt(item.mobilePhone);
            item.password = Decrypt(item.password);
          });
        }
        this.setState({
          list: res.data.list,
          total: res.data.total,
        });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      list,
      listQuery,
      total,
      isAdd,
      visible,
      employeeInfo,
      employeesId,
      deletevisible,
    } = this.state;
    return (
      <div className="container">
        <Headers BreadCrumbData={BreadCrumbData}></Headers>
        <div className="searchTitle">
          <Row>
            <Col span={20}>
              <Form layout="inline" onSubmit={this.handleSubmit}>
                <Form.Item>
                  {getFieldDecorator(
                    "name",
                    {}
                  )(
                    <Input
                      style={{ width: 170 }}
                      placeholder="姓名"
                      allowClear
                    />
                  )}
                </Form.Item>
                <Form.Item>
                  {getFieldDecorator(
                    "mobilePhone",
                    {}
                  )(
                    <Input
                      style={{ width: 170 }}
                      placeholder="联系方式"
                      allowClear
                    />
                  )}
                </Form.Item>

                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    搜索
                  </Button>
                </Form.Item>
              </Form>
            </Col>
            <Col span={4} align="right">
              <Button
                type="primary"
                onClick={() => this.setState({ visible: true, isAdd: true })}
              >
                新增人员
              </Button>
            </Col>
          </Row>
        </div>
        <div className="content">
          <Table
            rowKey="mobilePhone"
            dataSource={list}
            // locale={{ emptyText: "暂无商户" }}
            pagination={{
              showTotal: () => `共${total}条`,
              total: total,
              current: listQuery.pageNum,
              pageSize: listQuery.pageSize,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: ["10", "20", "30", "40", "100"],
              onChange: (page, pageSize) => {
                this.setState(
                  {
                    listQuery: { ...listQuery, pageNum: page },
                  },
                  () => this.getEmployeeList()
                );
              },
              onShowSizeChange: (current, pageSize) => {
                this.setState(
                  {
                    listQuery: { ...listQuery, pageSize, pageNum: 1 },
                  },
                  () => this.getEmployeeList()
                );
              },
            }}
          >
            <Column title="人员姓名" dataIndex="name" key="name" />
            <Column
              title="安装账号"
              dataIndex="mobilePhone"
              key="mobilePhone"
            />
            <Column title="密码" dataIndex="password" key="password" />
            <Column
              title="操作"
              render={(record) => {
                return (
                  <React.Fragment>
                    <a
                      onClick={() =>
                        this.setState({
                          employeeInfo: record,
                          isAdd: false,
                          visible: true,
                        })
                      }
                    >
                      编辑
                    </a>
                    <Divider type="vertical"></Divider>

                    <a
                      onClick={() =>
                        this.setState({
                          deletevisible: true,
                          employeesId: record.employeesId,
                        })
                      }
                    >
                      删除
                    </a>
                  </React.Fragment>
                );
              }}
            />
          </Table>
        </div>
        <EditInstallEmployee
          isAdd={isAdd}
          visible={visible}
          employeeInfo={employeeInfo}
          handleCancel={this.handleCancel}
          getEmployeeList={this.getEmployeeList}
        ></EditInstallEmployee>
        <Modal
          title="删除人员"
          visible={deletevisible}
          onOk={this.deleteOk}
          onCancel={() => this.setState({ deletevisible: false })}
        >
          <p>
            <Icon
              type="info-circle"
              theme="filled"
              style={{ color: "#FAAD14" }}
            />
            确定删除此人员？删除后无法登录零售设备进行安装操作。
          </p>
        </Modal>
      </div>
    );
  }
}
export default Form.create()(InstallEmployee);
